module.exports = "/img/_/_/_/assets/images/creeper/book/common//18.jpg?ba45e66654f5caacf0391bb6f5f585c5";